module.exports = __webpack_public_path__ + "img/yorubaland.e3118b4e.svg";